import { createContractRequest } from './helper';
export const getPolicyDetailsByPolicyNo = createContractRequest({
    route: '/contract/offers/policy/:policyNo/policydetails',
    method: 'get',
    source: 'data',
});
